import ChangeStatusForm from '#pages/order/ChangeStatus/ChangeStatusForm';
import { Modal, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Title } = Typography;

const ChangeStatusModal = ({
  visible,
  onCancel,
  onFinish = null,
  defaultValues,
}: {
  visible: boolean;
  onCancel: () => void;
  onFinish?: Parameters<typeof ChangeStatusForm>[0]['onFinish'];
  defaultValues?: Parameters<typeof ChangeStatusForm>[0]['defaultValues'];
}) => {
  const { t } = useTranslation('Vindoc');

  return (
    <Modal
      className="vindr-modal add-order max-w-screen"
      title={false}
      open={visible}
      maskClosable={false}
      destroyOnClose
      zIndex={1001}
      onCancel={onCancel}
      footer={null}
      width={900}
    >
      <Title level={3} className="mb-6">
        {t('Change Status')}
      </Title>
      <ChangeStatusForm {...{ onCancel, onFinish, defaultValues }} />
    </Modal>
  );
};

export default ChangeStatusModal;
